import type { Component } from '../router';
import { HealthPill } from './HealthPill';
import { TopNav, TabBar } from './nav/AppNav';
import { SiteFooter } from './nav/SiteFooter';

// isActiveTab moved to the nav model in ; re-exported here so existing
// importers (icons.test) keep their path.
export { isActiveTab } from './nav/navModel';

// AppShell — the app-shell layout primitive: the three regions every
// signed-in screen shares — top navigation, a centred content column, and the
// phone bottom navigation. Theme-aware (everything inherits the root data-theme
// tokens) and auth-aware (the navs filter to what this role + device class can
// reach, ). The shell mounts both navs; nav.css shows the right one for
// the viewport, so there is no device branch here.
export class AppShell implements Component {
  private root: HTMLElement | null = null;
  private readonly topNav = new TopNav();
  private readonly tabBar = new TabBar();
  private readonly footer = new SiteFooter();
  private phonePill: HealthPill | null = null;

  constructor(private inner: Component) {}

  mount(host: HTMLElement): void {
    const shell = document.createElement('div');
    shell.className = 'shell';

    this.topNav.mount(shell);

    const main = document.createElement('main');
    main.className = 'shell__main';
    shell.appendChild(main);

    // The storefront footer (legal nav) sits beneath the content column. It lives
    // between the main content and the phone tab bar so it reads as the end of the
    // page on desktop and above the thumb nav on phone.
    this.footer.mount(shell);

    this.tabBar.mount(shell);

    // Phone-only floating health chip (the top nav, which carries the desktop
    // pill, is hidden below 768px).
    const phoneHealth = document.createElement('div');
    phoneHealth.className = 'healthpill-phone';
    shell.appendChild(phoneHealth);
    this.phonePill = new HealthPill();
    this.phonePill.mount(phoneHealth);

    host.appendChild(shell);
    this.root = shell;
    this.inner.mount(main);
  }

  unmount(): void {
    this.phonePill?.unmount();
    this.phonePill = null;
    this.tabBar.unmount();
    this.footer.unmount();
    this.topNav.unmount();
    if (this.inner.unmount) this.inner.unmount();
    this.root?.remove();
    this.root = null;
  }
}
